export enum DiagnoseSicherheitEnum {
  GesicherteDiagnose = 'G',
  Ausschluss = 'A',
  VerdachtAuf = 'V',
  ZustandNach = 'Z',
}

export enum DiagnoseSicherheitDisplayName {
  GesicherteDiagnose = 'gesicherte Diagnose',
  Ausschluss = 'Ausschluss',
  VerdachtAuf = 'Verdacht auf',
  ZustandNach = 'Zustand nach',
}

export interface DiagnoseSicherheitOption {
  id: DiagnoseSicherheitEnum;
  name: DiagnoseSicherheitDisplayName;
}

export const diagnoseSicherheitOptions: DiagnoseSicherheitOption[] = [
  {
    id: DiagnoseSicherheitEnum.GesicherteDiagnose,
    name: DiagnoseSicherheitDisplayName.GesicherteDiagnose,
  },
  {
    id: DiagnoseSicherheitEnum.Ausschluss,
    name: DiagnoseSicherheitDisplayName.Ausschluss,
  },
  {
    id: DiagnoseSicherheitEnum.VerdachtAuf,
    name: DiagnoseSicherheitDisplayName.VerdachtAuf,
  },
  {
    id: DiagnoseSicherheitEnum.ZustandNach,
    name: DiagnoseSicherheitDisplayName.ZustandNach,
  },
];
